import makeStateFilter from '../../make-state-filter';

import { stateFilter as parentStateFilter } from '../reducer.metadata';

const namespace = 'carrierSharing';
const stateFilter = makeStateFilter(parentStateFilter, namespace);

export { namespace, stateFilter };
